import { Address } from 'types/domain';

const inlineAddress = (address: Address) => {
    const address2 = address.address_2 ? ` ${address.address_2}` : '';
    const line1 = `${address.address_1 ?? ''}${address2}`;
    const cityState = `${address.city ?? ''}, ${address.state ?? ''}`;
    const countryZip = `${address.country ?? ''} ${address.zipcode ?? ''}`;

    return `${line1}, ${cityState}, ${countryZip}`;
};

const isUSA = (value: string | null) =>
    value === null ||
    ['usa', 'us', 'united states', 'united states of america'].includes(
        value.replaceAll('.', '').toLowerCase(),
    );

export { inlineAddress, isUSA };
